import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '@/utils/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('dyvy_token');
    const savedUser = localStorage.getItem('dyvy_user');
    
    if (token && savedUser) {
      // Charger immédiatement l'utilisateur depuis le localStorage
      setUser(JSON.parse(savedUser));
      setLoading(false); // Débloquer immédiatement l'interface
      
      // Vérifier le token en arrière-plan (sans bloquer)
      api.get('/auth/me')
        .then(res => {
          setUser(res.data);
          localStorage.setItem('dyvy_user', JSON.stringify(res.data));
        })
        .catch(() => {
          // Token invalide, déconnecter
          logout();
        });
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (phoneNumber, password) => {
    const res = await api.post('/auth/login', { phone_number: phoneNumber, password });
    const { token, user: userData } = res.data;
    
    localStorage.setItem('dyvy_token', token);
    localStorage.setItem('dyvy_user', JSON.stringify(userData));
    setUser(userData);
    
    return userData;
  };

  const register = async (formData) => {
    const res = await api.post('/auth/register', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    const { token, user: userData } = res.data;
    
    localStorage.setItem('dyvy_token', token);
    localStorage.setItem('dyvy_user', JSON.stringify(userData));
    setUser(userData);
    
    return userData;
  };

  const logout = async () => {
    try {
      await api.post('/auth/logout');
    } catch (e) {
      // Ignore errors
    }
    localStorage.removeItem('dyvy_token');
    localStorage.removeItem('dyvy_user');
    setUser(null);
    window.location.href = '/auth';
  };

  // Fonction globale pour vérifier si l'utilisateur est Admin Adil (tous les services GRATUITS)
  const isAdminAdil = () => {
    if (!user) return false;
    
    // Vérifier par rôle
    if (user.role === 'admin' || user.role === 'super_admin') return true;
    
    // Vérifier par numéro de téléphone (compte Adil)
    if (user.phone_number === '+243808408407') return true;
    
    // Vérifier par email (si vous avez un email)
    if (user.email && (user.email.toLowerCase() === 'adil@agrpbox.com' || user.email.toLowerCase() === 'admin@agrpbox.com')) return true;
    
    // Vérifier par username
    if (user.username && (user.username.toLowerCase() === 'agp' || user.username.toLowerCase() === 'adils')) return true;
    
    return false;
  };

  const value = {
    user,
    loading,
    login,
    register,
    logout,
    isAuthenticated: !!user,
    isAdmin: user?.role === 'admin' || user?.role === 'super_admin',
    isAdminAdil: isAdminAdil()
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};